import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";
import {CreditCardLogo} from "../../CreditCardLogo/CreditCardLogo";

import "./PayrixCreditCardInput.scss";

interface PayrixCreditCardInputProps {
    creditCard: string;
    onSetCreditCard: (amount: string) => void;
    onSetIsCreditCardValid: (isAmountValid: boolean) => void;
}

export const PayrixCreditCardInput: React.FunctionComponent<PayrixCreditCardInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const [isMasked, setMasked] = useState<boolean>(false);
    const requiredCardholderNameError = 'Credit Card is a required field.';
    const incorrectCardholderNameError = 'Credit Card should be from 13 to 16 digit.';

    useEffect(() => {
        props.onSetIsCreditCardValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        value = value.replace(/\D/g, '');
        props.onSetCreditCard(value);
        validateCreditCard(value);
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateCreditCard();
    }

    const onBlur = () => {
        setMasked(true);
    }

    const onClick = () => {
        setMasked(false);
    }

    const getCardValue = () => {
        if (props.creditCard && isValid && isMasked) {
            const maskedPart = '*'.repeat(props.creditCard.length - 8);
            return `${props.creditCard.slice(0, 4)}${maskedPart}${props.creditCard.slice(props.creditCard.length - 4)}`
        }
        return props.creditCard;
    }

    const validateCreditCard = (creditCard: string = '') => {
        creditCard = creditCard || props.creditCard;
        let errorsTemp: string[] = [];
        if (creditCard === '') {
            errorsTemp.push(requiredCardholderNameError);
        }
        if (creditCard.length < 13 || creditCard.length > 16) {
            errorsTemp.push(incorrectCardholderNameError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div className="payrix-credit-card-container">
        <Input isValid={isValid} type='text' required={true} value={getCardValue()} onChange={onChange}
               onKeyUp={onKeyUp} onBlur={onBlur} onClick={onClick}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
        <CreditCardLogo creditCard={props.creditCard}/>
    </div>
}
